import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-employee-tooltip-dialog',
  templateUrl: './employee-tooltip-dialog.component.html',
  styleUrls: ['./employee-tooltip-dialog.component.scss'],
})
export class EmployeeTooltipDialogComponent  implements OnInit {
  employeesWithColor: any[] = [];
  

  constructor(
    public dialogRef: MatDialogRef<EmployeeTooltipDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  



  ngOnInit() {
    if (!Array.isArray(this.data.employees)) {
    
    
      this.data.employees = []; 
    }
    if (!Array.isArray(this.data.departmentsColor)) {
      console.error('Error: departmentsColor is not an array', this.data);
      this.data.departmentsColor = [];
    }
  
    
    this.data.employees = this.data.employees.map((emp: any) => {
      const department = this.data.departmentsColor.find(
        (dept: any) => dept.departmentName === emp.department
      );
      return {
        ...emp,
        departmentColor: department ? department.departmentColor : '#ffffff' 
      };
    });
  }



  downloadTrendReport(employees: any[]) {
    const header = ["Employee Name", "Department"];
    const csvRows = [header];
  
    employees.forEach((emp: any) => {
      csvRows.push([
        emp.employeeName,
        emp.department
      ]);
    });
  
    let csvContent = "data:text/csv;charset=utf-8," + csvRows.map(row => row.join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "employeesData.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  
  

}
